import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {
  Cancel,
  Check,
  HourglassEmpty,
  HourglassFull,
  Warning,
} from '@mui/icons-material';

const LABELS = {
  BUILDING: 'Setting up your blog',
  READY: 'Online',
  ERROR: 'Something went wrong',
  PUBLISH_FAILED: 'Your blog could not go online — contact us',
};

export default function DeploymentStateIndicator({ state }) {
  let icon = (
    <span className="text-warning">
      <HourglassFull />
    </span>
  );
  if (state === 'BUILDING') {
    icon = (
      <span className="text-warning">
        <HourglassEmpty />
      </span>
    );
  }
  if (state === 'ERROR' || state === 'PUBLISH_FAILED') {
    icon = (
      <span className="text-danger">
        <Cancel />
      </span>
    );
  }
  if (state === 'READY') {
    icon = (
      <span className="text-success">
        <Check />
      </span>
    );
  }
  if (state === 'Plan expired') {
    icon = (
      <span className="text-danger">
        <Warning />
      </span>
    );
  }

  //   Possible values are BUILDING, READY, ERROR, PUBLISH_FAILED (v2) or
  //   'Plan expired'

  return (
    <div className="mr-2" style={{ width: 30 }}>
      {state && (
        <Tooltip title={LABELS[state] || state}>
          <IconButton size="small" aria-label="Deployment state">
            {icon}
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
}
